/**
 * ymm-filter.js  (v11 — Year-first: Year / Make / Model / Engine)
 * File: assets/ymm-filter.js
 *
 * Identical to v10 except:
 *   - Modal dropdown order: Year → Make → Model → Engine
 *   - New helpers: getAllYears(), getMakesForYear(year), getModelsForYear(make, year)
 *   - YEAR_MAP_2 extended to V:2027, W:2028
 *   - Everything else (results overlay, Motul strip, VIN decoder,
 *     fitment badge, cat_index loading) is unchanged.
 */

(function () {
  'use strict';

 const MOTUL_ADDITIVES = [
  {sku:"MT110709",title:"Motul Anti-Humos Diesel",url:"/products/mt110709",img:"https://cdn.shopify.com/s/files/1/0560/9032/9197/files/D_855269-MLM89474361309_082025-F.jpg?v=1792004968",price:169.29},
  {sku:"MT110697",title:"Motul Anti-Humos Gasolina",url:"/products/mt110697",img:"https://cdn.shopify.com/s/files/1/0560/9032/9197/files/D_718376-MLM109373700796_042026-F_47175c37-d1f5-457d-ad44-1e3132fe5ec4.jpg?v=1789591978",price:230.00},
  {sku:"MT110713",title:"Motul Arranque Sin Ruido",url:"/products/mt110713",img:"https://cdn.shopify.com/s/files/1/0560/9032/9197/files/D_606096-MLM98894747685_112025-F_f7130b92-8650-40fc-97d6-9a01e1baa6ad.jpg?v=1789591980",price:240.92},
  {sku:"MT110730",title:"Motul DPF Cleaner Diesel",url:"/products/mt110730",img:"https://cdn.shopify.com/s/files/1/0560/9032/9197/files/D_940963-MLM109374171568_042026-F_716cbb4f-a4bc-4a56-b6a2-9e0b887b871e.jpg?v=1789591981",price:352.75},
  {sku:"MT110711",title:"Motul Limpia Catalizadores",url:"/products/mt110711",img:"https://cdn.shopify.com/s/files/1/0560/9032/9197/files/D_956398-MLM98894717869_112025-F_c04a7170-b0c8-4486-86b1-25c87d4e8a6e.jpg?v=1789591979",price:231.93},
  {sku:"MT110708",title:"Motul Limpia Inyectores Diesel",url:"/products/mt110708",img:"https://cdn.shopify.com/s/files/1/0560/9032/9197/files/D_631372-MLM107648022478_032026-F_e95e4d26-0725-4f82-9f79-6d7c1745b311.jpg?v=1789591978",price:203.32},
  {sku:"MT110696",title:"Motul Limpia Inyectores Gasolina",url:"/products/mt110696",img:"https://cdn.shopify.com/s/files/1/0560/9032/9197/files/D_904869-MLM98416530114_112025-F_90a6acb8-b00a-4942-a5fa-d105c5bae84f.jpg?v=1789591977",price:196.02},
  {sku:"MT110793",title:"Motul Limpieza Interna Motor",url:"/products/mt110793",img:"https://cdn.shopify.com/s/files/1/0560/9032/9197/files/D_685898-MLM98417322814_112025-F_5897a1fa-e3e6-4e2e-9466-0eb08cc0c83e.jpg?v=1789591982",price:203.32},
  {sku:"MT110712",title:"Motul Sella Fugas de Aceite",url:"/products/mt110712",img:"https://cdn.shopify.com/s/files/1/0560/9032/9197/files/D_885042-MLM98419501378_112025-F_ba196a93-e774-4d09-8fce-6d4d0d8a6e91.jpg?v=1789591980",price:349.69},
  {sku:"MT110714",title:"Motul Sella Fugas de Radiador",url:"/products/mt110714",img:"https://cdn.shopify.com/s/files/1/0560/9032/9197/files/D_674553-MLM98419282526_112025-F_2d74a361-5040-4846-98db-f634f5ed589d.jpg?v=1789591981",price:281.90},
];

  function buildMotulStrip() {
    const fmt = price => '$' + parseFloat(price).toLocaleString('es-MX', {minimumFractionDigits:2}) + ' MXN';
    const cards = MOTUL_ADDITIVES.map(p => `
      <a href="${p.url}" class="ymm-motul__card">
        <div class="ymm-motul__img-wrap"><img src="${p.img}" alt="${p.title}" loading="lazy"></div>
        <div class="ymm-motul__info">
          <p class="ymm-motul__title">${p.title}</p>
          <p class="ymm-motul__price">${fmt(p.price)}</p>
        </div>
      </a>`).join('');
    return `<div class="ymm-motul">
      <div class="ymm-motul__header">
        <span class="ymm-motul__logo">&#x1F6E2;</span>
        <span class="ymm-motul__label">Complementa el mantenimiento de tu veh&#xED;culo</span>
        <a href="/collections/aceites-y-aditivos-motul" class="ymm-motul__link">Ver todo Motul &rarr;</a>
      </div>
      <div class="ymm-motul__grid">${cards}</div>
    </div>`;
  }

  const STORAGE_KEY   = 'ymm_vehicle';
  const RESULTS_LIMIT = 20;
  let catIndex = {};

  function slugify(str) {
    return str.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,'_').replace(/[^a-z0-9_]/g,'');
  }

  // Derives the product tag slug from a full TecDoc model string.
  // Matches generate_shopify_tags.py: first 2 words before ( or /
  // e.g. "3 Coupé (E92)"  -> "model_3_coupe"
  //      "GOLF VII (5G1)" -> "model_golf_vii"
  //      "3 (E90)"        -> "model_3"
  function modelSlug(fullModel) {
    const stripped = fullModel.replace(/\s*[\(/,].*/, '').trim();
    const words = stripped.split(/\s+/).slice(0, 2).join(' ');
    return 'model_' + slugify(words);
  }
  function getVehicle()   { try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)); } catch(e) { return null; } }
  function saveVehicle(v) { try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(v)); } catch(e) {} }
  function clearVehicle() { try { sessionStorage.removeItem(STORAGE_KEY); } catch(e) {} }
  function fmt(price)     { return '$' + parseFloat(price).toLocaleString('es-MX', {minimumFractionDigits:2}) + ' MXN'; }

  async function loadData() {
    try { catIndex = await (await fetch(window.YMM_CAT_INDEX_URL)).json(); }
    catch(e) { console.warn('YMM: could not load cat_index', e); }
  }

  // ── cat_index helpers (original, unchanged) ───────────────────────────────
  function getAllMakes() {
    const makes = new Set();
    Object.values(catIndex).forEach(cat => Object.keys(cat).forEach(m => makes.add(m)));
    return [...makes].sort();
  }
  function getModels(make) {
    const models = new Set();
    Object.values(catIndex).forEach(cat => { if(cat[make]) Object.keys(cat[make]).forEach(m => models.add(m)); });
    return [...models].sort();
  }
  function getYears(make, model) {
    const years = new Set();
    Object.values(catIndex).forEach(cat => { if(cat[make]?.[model]) Object.keys(cat[make][model]).forEach(y => years.add(y)); });
    return [...years].sort((a,b) => b-a);
  }
  function getEngines(make, model, year) {
    const engines = new Set();
    Object.values(catIndex).forEach(cat => {
      const yd = cat[make]?.[model]?.[year];
      if(yd) { if(Array.isArray(yd)) yd.forEach(e => engines.add(e)); else Object.keys(yd).forEach(e => engines.add(e)); }
    });
    return [...engines].sort();
  }
  function getTypeIDs(make, model, year, engine) {
    const ids = new Set();
    Object.values(catIndex).forEach(cat => {
      const yd = cat[make]?.[model]?.[year];
      if(!yd || Array.isArray(yd)) return;
      (yd[engine] || []).forEach(id => ids.add(id));
    });
    return [...ids];
  }

  // ── NEW: year-first helpers ───────────────────────────────────────────────
  function getAllYears() {
    const years = new Set();
    Object.values(catIndex).forEach(cat =>
      Object.values(cat).forEach(makeObj =>
        Object.values(makeObj).forEach(modelObj =>
          Object.keys(modelObj).forEach(y => years.add(y))
        )
      )
    );
    return [...years].sort((a, b) => b - a); // newest first
  }

  function getMakesForYear(year) {
    const makes = new Set();
    Object.values(catIndex).forEach(cat =>
      Object.entries(cat).forEach(([make, makeObj]) => {
        if (Object.values(makeObj).some(modelObj => year in modelObj))
          makes.add(make);
      })
    );
    return [...makes].sort();
  }

  function getModelsForYear(make, year) {
    const models = new Set();
    Object.values(catIndex).forEach(cat => {
      const makeObj = cat[make];
      if (!makeObj) return;
      Object.entries(makeObj).forEach(([model, modelObj]) => {
        if (year in modelObj) models.add(model);
      });
    });
    return [...models].sort();
  }
  // ─────────────────────────────────────────────────────────────────────────

  function fillSelect(sel, options, placeholder) {
    sel.innerHTML = `<option value="">${placeholder}</option>`;
    options.forEach(o => { const opt = document.createElement('option'); opt.value = opt.textContent = o; sel.appendChild(opt); });
    sel.disabled = options.length === 0;
  }

  // ── OFFLINE VIN DECODER ───────────────────────────────────────────────────
  const YEAR_MAP = {
    'A':1980,'B':1981,'C':1982,'D':1983,'E':1984,'F':1985,'G':1986,'H':1987,
    'J':1988,'K':1989,'L':1990,'M':1991,'N':1992,'P':1993,'R':1994,'S':1995,
    'T':1996,'V':1997,'W':1998,'X':1999,'Y':2000,
    '1':2001,'2':2002,'3':2003,'4':2004,'5':2005,'6':2006,'7':2007,'8':2008,'9':2009,
  };
  // 2010+ cycle (A-Y repeat, skip I O Q) — extended to 2028
  const YEAR_MAP_2 = {
    'A':2010,'B':2011,'C':2012,'D':2013,'E':2014,'F':2015,'G':2016,'H':2017,
    'J':2018,'K':2019,'L':2020,'M':2021,'N':2022,'P':2023,'R':2024,'S':2025,
    'T':2026,'V':2027,'W':2028,
  };

  function decodeYear(vin) {
    const ch = vin[9];
    if (YEAR_MAP_2[ch]) return YEAR_MAP_2[ch];
    if (YEAR_MAP[ch])   return YEAR_MAP[ch];
    return null;
  }

  const WMI_MAP = {
    'WBA':'Bmw','WBB':'Bmw','WBC':'Bmw','WBD':'Bmw','WBE':'Bmw',
    'WBS':'Bmw','WBY':'Bmw','WBX':'Bmw','5UX':'Bmw','5YM':'Bmw','3MW':'Bmw',
    'WDB':'Mercedes-Benz','WDC':'Mercedes-Benz','WDD':'Mercedes-Benz',
    'WDF':'Mercedes-Benz','WDH':'Mercedes-Benz','WME':'Mercedes-Benz',
    '4JG':'Mercedes-Benz','55S':'Mercedes-Benz',
    'WVW':'Vw','WV1':'Vw','WV2':'Vw','WV3':'Vw','3VW':'Vw','9BW':'Vw','9BM':'Vw','1VW':'Vw','2V4':'Vw',
    'WAU':'Audi','WA1':'Audi','TRU':'Audi','1A8':'Audi',
    'WP0':'Porsche','WP1':'Porsche','WP9':'Porsche',
    'VSS':'Seat','VS6':'Seat','VS7':'Seat',
    'TMB':'Skoda',
    'YV1':'Volvo','YV4':'Volvo','XLB':'Volvo',
    'WMW':'Mini',
    'ZAR':'Alfa Romeo','ZFA':'Fiat','ZFF':'Fiat','ZFB':'Fiat','ZFC':'Fiat',
    'VF3':'Peugeot','VF7':'Peugeot','VF8':'Peugeot',
    'VF1':'Renault','VF6':'Renault',
    '1FA':'Ford','1FB':'Ford','1FC':'Ford','1FD':'Ford','1FM':'Ford',
    '1FT':'Ford','2FM':'Ford','2FT':'Ford','3FA':'Ford','3FE':'Ford','WF0':'Ford',
    '1G1':'Chevrolet','1G4':'Buick','1G6':'Cadillac','1GC':'Chevrolet',
    '1GM':'Pontiac','1GT':'Gmc','2G1':'Chevrolet','3G1':'Chevrolet',
    'KL1':'Chevrolet','KL8':'Chevrolet',
    '1N4':'Nissan','1N6':'Nissan','JN1':'Nissan','JN8':'Nissan','3N1':'Nissan','3N6':'Nissan',
    'JT2':'Toyota','JT3':'Toyota','JT4':'Toyota','JTE':'Toyota','JTF':'Toyota',
    'JTJ':'Toyota','JTK':'Toyota','JTL':'Toyota','JTM':'Toyota','JTN':'Toyota','JTP':'Toyota',
    '2T1':'Toyota','2T2':'Toyota','4T1':'Toyota','4T3':'Toyota',
    '5TB':'Toyota','5TD':'Toyota','5TE':'Toyota','5TF':'Toyota',
    '1HG':'Honda','2HG':'Honda','5FN':'Honda','JHM':'Honda','19X':'Honda','19U':'Honda',
    'JM1':'Mazda','JM3':'Mazda','4F2':'Mazda',
    '1B3':'Dodge','1C3':'Chrysler','1C4':'Jeep','1C6':'Dodge',
    '2B3':'Dodge','2C3':'Chrysler','3C4':'Chrysler','3C6':'Dodge','3D4':'Dodge',
    '1J4':'Jeep','1J8':'Jeep',
    'KMH':'Hyundai','KM8':'Hyundai','5NM':'Hyundai','5NP':'Hyundai',
    'KNA':'Kia','KND':'Kia','5XX':'Kia',
    'JA3':'Mitsubishi','JA4':'Mitsubishi','JA8':'Mitsubishi','ML3':'Mitsubishi',
    'JF1':'Subaru','JF2':'Subaru','4S3':'Subaru','4S4':'Subaru',
    'JS2':'Suzuki','JS3':'Suzuki',
    'JNK':'Infiniti',
    'JTH':'Lexus',
    'SAJ':'Jaguar','SAL':'Land Rover','SAR':'Land Rover',
    '1LN':'Lincoln','2LM':'Lincoln','5LM':'Lincoln',
    'YS3':'Saab',
    'VSE':'Cupra',
  };

  function decodeMakeFromWMI(vin) {
    const wmi3 = vin.substring(0, 3).toUpperCase();
    const wmi2 = vin.substring(0, 2).toUpperCase();
    return WMI_MAP[wmi3] || WMI_MAP[wmi2] || null;
  }

  async function decodeVIN(vin) {
    vin = vin.toUpperCase().trim();
    if (vin.length !== 17) throw new Error('El VIN debe tener 17 caracteres');
    if (/[IOQ]/.test(vin)) throw new Error('VIN inv\xE1lido: no puede contener I, O o Q');

    const year = decodeYear(vin);
    const make = decodeMakeFromWMI(vin);
    if (!year) throw new Error('No se pudo determinar el a\xF1o del VIN');

    let model = '';
    try {
      const res = await fetch(`https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/${vin}?format=json`);
      if (res.ok) {
        const data = await res.json();
        const r = data.Results?.[0];
        if (r && r.Model && r.Model !== 'Not Applicable' && r.Model !== '') model = r.Model;
      }
    } catch(e) {}

    return { make, model, year: String(year), source: make ? 'Offline+NHTSA' : 'NHTSA' };
  }

  // ── Smart model matching ──────────────────────────────────────────────────
  function findModelsForYear(make, year) {
    return getModelsForYear(make, year); // uses new year-first helper
  }

  function scoreModelMatch(tecDocModel, nhtsaModel) {
    if (!nhtsaModel) return 0;
    const td = tecDocModel.toLowerCase().trim();
    const nh = nhtsaModel.toLowerCase().trim()
                 .replace(/\s+series$/,'').replace(/\s+class$/,'').replace(/-class$/,'').trim();
    const nhBase = nh.split(/[\s\-\/]/)[0];
    if (td === nh) return 100;
    if (td.startsWith(nhBase + ' ') || td === nhBase) return 80;
    if (nh.startsWith(td.split(' ')[0])) return 60;
    if (td.includes(nhBase) || nhBase.includes(td.split(' ')[0])) return 40;
    return 0;
  }

  function findBestModels(make, nhtsaModel, year) {
    const candidates = findModelsForYear(make, year);
    if (!candidates.length) return [];
    if (!nhtsaModel) return candidates;
    const scored = candidates
      .map(m => ({ model: m, score: scoreModelMatch(m, nhtsaModel) }))
      .filter(x => x.score > 0)
      .sort((a,b) => b.score - a.score);
    const good = scored.filter(x => x.score >= 40);
    return good.length > 0 ? good.map(x => x.model) : candidates;
  }

  // ── VIN input ─────────────────────────────────────────────────────────────
  function initVINInput() {
    const vinInput  = document.getElementById('ymm-vin-input');
    const vinSubmit = document.getElementById('ymm-vin-submit');
    const vinStatus = document.getElementById('ymm-vin-status');
    if (!vinInput) return;

    vinInput.addEventListener('input', () => {
      const val = vinInput.value.replace(/[^a-zA-Z0-9]/g,'').toUpperCase();
      vinInput.value = val;
      vinSubmit.disabled = val.length !== 17;
      vinStatus.textContent = '';
      vinStatus.className = 'ymm-bar__vin-status';
    });
    vinInput.addEventListener('keydown', e => { if(e.key==='Enter' && !vinSubmit.disabled) vinSubmit.click(); });

    vinSubmit.addEventListener('click', async () => {
      const vin = vinInput.value.trim();
      vinStatus.textContent = 'Decodificando...';
      vinStatus.className = 'ymm-bar__vin-status';
      vinSubmit.disabled = true;

      try {
        const decoded = await decodeVIN(vin);
        const { make, model, year } = decoded;

        const catalogMakes = getAllMakes();
        if (!make || !catalogMakes.includes(make)) {
          const wmi = vin.substring(0,3);
          vinStatus.textContent = `VIN decodificado: a\xF1o ${year} \u2014 Marca (${wmi}) no en cat\xE1logo`;
          vinStatus.className = 'ymm-bar__vin-status error';
          vinSubmit.disabled = false;
          return;
        }

        const bestModels    = findBestModels(make, model, year);
        const allYearModels = findModelsForYear(make, year);

        if (allYearModels.length === 0) {
          vinStatus.textContent = `${make} ${year} \u2014 Sin partes disponibles para este a\xF1o`;
          vinStatus.className = 'ymm-bar__vin-status error';
          vinSubmit.disabled = false;
          return;
        }

        if (bestModels.length === 1) {
          const engines = getEngines(make, bestModels[0], year);
          if (engines.length === 1) {
            const vehicle = { make, model: bestModels[0], year, engine: engines[0] };
            saveVehicle(vehicle);
            updateBar();
            vinStatus.textContent = `\u2713 ${make} ${bestModels[0]} ${year}`;
            vinStatus.className = 'ymm-bar__vin-status success';
            doSearch(vehicle);
            return;
          }
        }

        const modelCount = bestModels.length || allYearModels.length;
        vinStatus.textContent = `\u2713 ${make} ${year} \u2014 ${modelCount > 1 ? 'Selecciona tu variante:' : 'Confirma tu motor:'}`;
        vinStatus.className = 'ymm-bar__vin-status success';
        buildModal(null, {
          make,
          year,
          modelFilter: bestModels.length > 0 ? bestModels : allYearModels
        });

      } catch(e) {
        vinStatus.textContent = e.message || 'No se pudo decodificar el VIN';
        vinStatus.className = 'ymm-bar__vin-status error';
        vinSubmit.disabled = false;
      }
    });
  }

  // ── Search ────────────────────────────────────────────────────────────────
  async function searchByVehicle(vehicle) {
    const { make, model, year, engine } = vehicle;
    const typeIds = getTypeIDs(make, model, year, engine);
    const searchTag = typeIds.length > 0 ? 'type_'+typeIds[0] : 'make_'+slugify(make);
    const query     = typeIds.length > 0 ? searchTag : searchTag+' '+modelSlug(model);
    const suggestUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[options][fields]=tag,title&resources[limit]=${RESULTS_LIMIT}`;
    const searchUrl  = `/search?type=product&q=${encodeURIComponent('tag:'+searchTag)}`;
    try {
      const [suggestRes, countRes] = await Promise.all([fetch(suggestUrl), fetch(searchUrl)]);
      const data = await suggestRes.json();
      const products = data.resources?.results?.products || [];
      let totalCount = products.length;
      try { const html = await countRes.text(); const m = html.match(/(\d+)\s+resultado/); if(m) totalCount = parseInt(m[1]); } catch(e) {}
      return { products, totalCount, searchUrl };
    } catch(e) { return { products:[], totalCount:0, searchUrl }; }
  }

  function showResults(vehicle, products, totalCount, searchUrl) {
    document.getElementById('ymm-results-overlay')?.remove();
    const vehicleStr = `${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.engine||''}`.trim();
    const overlay = document.createElement('div');
    overlay.id = 'ymm-results-overlay';

    if (!products.length) {
      overlay.innerHTML = `<div class="ymm-results__backdrop" id="ymm-results-backdrop"></div>
        <div class="ymm-results__panel"><div class="ymm-results__header">
          <div><h2 class="ymm-results__title">Partes para tu ${vehicleStr}</h2>
          <p class="ymm-results__sub">No encontramos partes para este veh\xEDculo.</p></div>
          <button class="ymm-results__close" id="ymm-results-close">&#10005;</button>
        </div></div>`;
    } else {
      const cards = products.map(p => {
        const price = p.price ? fmt(p.price) : '';
        const hasDiscount = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price);
        const compare = hasDiscount ? `<span class="ymm-card__compare">${fmt(p.compare_at_price_max)}</span>` : '';
        const badge   = hasDiscount ? `<span class="ymm-card__badge">Oferta</span>` : '';
        const imgUrl  = (p.featured_image&&p.featured_image.url)||(typeof p.featured_image==='string'?p.featured_image:'')||(p.image&&p.image.url)||(typeof p.image==='string'?p.image:'')||'';
        const imgHtml = imgUrl ? `<img src="${imgUrl}" alt="${p.title}" loading="lazy">` : `<div class="ymm-card__no-img">Sin imagen</div>`;
        return `<a href="${p.url}" class="ymm-card">
          <div class="ymm-card__img-wrap">${imgHtml}${badge}</div>
          <div class="ymm-card__info"><p class="ymm-card__title">${p.title}</p><p class="ymm-card__price">${price}${compare}</p></div>
        </a>`;
      }).join('');
      overlay.innerHTML = `<div class="ymm-results__backdrop" id="ymm-results-backdrop"></div>
        <div class="ymm-results__panel">
          <div class="ymm-results__header">
            <div><h2 class="ymm-results__title">Partes para tu ${vehicleStr}</h2>
            <p class="ymm-results__sub">${Math.max(totalCount,products.length)} resultado${totalCount!==1?'s':''} encontrado${totalCount!==1?'s':''}</p>
            <a href="${searchUrl}" class="ymm-results__all-btn">Ver todos los resultados &rarr;</a></div>
            <button class="ymm-results__close" id="ymm-results-close">&#10005;</button>
          </div>
          <div class="ymm-results__grid">${cards}</div>
          ${buildMotulStrip()}
        </div>`;
    }

    const style = document.createElement('style');
    style.textContent = `
      #ymm-results-overlay{position:fixed;inset:0;z-index:10000;display:flex;align-items:flex-end;justify-content:center}
      .ymm-results__backdrop{position:absolute;inset:0;background:rgba(0,0,0,0.6)}
      .ymm-results__panel{position:relative;background:#fff;width:100%;max-width:1100px;max-height:92vh;border-radius:16px 16px 0 0;overflow:hidden;display:flex;flex-direction:column;z-index:1;box-shadow:0 -4px 32px rgba(0,0,0,0.2)}
      .ymm-results__header{display:flex;align-items:center;justify-content:space-between;padding:20px 24px 16px;border-bottom:1px solid #eee;background:#0E1B47;flex-shrink:0}
      .ymm-results__title{font-size:18px;font-weight:700;color:#fff;margin:0 0 4px}
      .ymm-results__sub{font-size:13px;color:rgba(255,255,255,0.75);margin:0}
      .ymm-results__close{background:rgba(255,255,255,0.15);border:none;color:#fff;width:32px;height:32px;border-radius:50%;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0}
      .ymm-results__close:hover{background:rgba(255,255,255,0.3)}
      .ymm-results__all-btn{display:inline-block;margin-top:8px;background:#A8202A;color:#fff !important;padding:6px 20px;border-radius:20px;font-size:13px;font-weight:700;text-decoration:none !important;white-space:nowrap}
      .ymm-results__all-btn:hover{background:#ff2828}
      .ymm-results__grid{display:grid;grid-template-columns:repeat(5,1fr);grid-auto-rows:220px;gap:12px;padding:16px 20px;overflow-y:auto;flex:1;min-height:0}
      .ymm-card{display:flex;flex-direction:column;text-decoration:none;border:1px solid #eee;border-radius:10px;overflow:hidden;transition:box-shadow 0.2s,transform 0.2s;background:#fff;height:100%}
      .ymm-card:hover{box-shadow:0 4px 16px rgba(0,0,0,0.12);transform:translateY(-2px)}
      .ymm-card__img-wrap{position:relative;width:100%;height:140px !important;min-height:140px !important;background:#f8f8f8;overflow:hidden;display:flex;align-items:center;justify-content:center;flex-shrink:0}
      .ymm-card__img-wrap img{max-width:100%;max-height:130px;object-fit:contain;padding:8px;box-sizing:border-box;display:block}
      .ymm-card__no-img{display:flex;align-items:center;justify-content:center;height:100%;color:#ccc;font-size:12px}
      .ymm-card__badge{position:absolute;top:8px;right:8px;background:#A8202A;color:#fff;font-size:10px;font-weight:700;padding:2px 6px;border-radius:4px}
      .ymm-card__info{padding:10px 12px}
      .ymm-card__title{font-size:12px;color:#333;margin:0 0 6px;line-height:1.4;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
      .ymm-card__price{font-size:13px;font-weight:700;color:#0E1B47;margin:0}
      .ymm-card__compare{font-size:11px;color:#999;text-decoration:line-through;margin-left:6px;font-weight:400}
      .ymm-motul{border-top:2px solid #0E1B47;padding:8px 20px 10px;background:#f5f7ff;flex-shrink:0}
      .ymm-motul__header{display:flex;align-items:center;gap:8px;margin-bottom:12px}
      .ymm-motul__logo{font-size:20px}
      .ymm-motul__label{font-size:13px;font-weight:600;color:#333;flex:1}
      .ymm-motul__link{font-size:12px;color:#0E1B47;text-decoration:none;white-space:nowrap}
      .ymm-motul__link:hover{text-decoration:underline}
      .ymm-motul__grid{display:flex;flex-direction:row;gap:10px;overflow-x:auto;padding-bottom:4px}
      .ymm-motul__card{min-width:160px;max-width:180px;flex-shrink:0;display:flex;flex-direction:column;text-decoration:none;border:1px solid #eee;border-radius:8px;overflow:hidden;background:#fff;transition:box-shadow 0.2s}
      .ymm-motul__card:hover{box-shadow:0 2px 8px rgba(0,0,0,0.1)}
      .ymm-motul__img-wrap{width:70px;height:70px;background:#f8f8f8;overflow:hidden;flex-shrink:0}
      .ymm-motul__img-wrap img{width:100%;height:100%;object-fit:contain;padding:4px}
      .ymm-motul__info{padding:0;flex:1}
      .ymm-motul__title{font-size:10px;color:#333;margin:0 0 3px;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
      .ymm-motul__price{font-size:11px;font-weight:700;color:#A8202A;margin:0}
      @media(max-width:600px){.ymm-results__grid{grid-template-columns:repeat(2,1fr);grid-auto-rows:190px;gap:8px;padding:10px 14px}.ymm-results__header{padding:16px}.ymm-results__title{font-size:15px}.ymm-card__img-wrap{height:110px !important;min-height:110px !important}.ymm-motul{padding:10px 14px 12px}.ymm-motul__card{min-width:140px}}
    `;
    document.head.appendChild(style);
    document.body.appendChild(overlay);
    document.getElementById('ymm-results-close')?.addEventListener('click', () => overlay.remove());
    document.getElementById('ymm-results-backdrop')?.addEventListener('click', () => overlay.remove());
    document.addEventListener('keydown', function esc(e) { if(e.key==='Escape'){overlay.remove();document.removeEventListener('keydown',esc);} });
  }

  function showLoading(vehicle) {
    document.getElementById('ymm-results-overlay')?.remove();
    const vehicleStr = `${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.engine||''}`.trim();
    const overlay = document.createElement('div');
    overlay.id = 'ymm-results-overlay';
    overlay.innerHTML = `<div class="ymm-results__backdrop"></div>
      <div class="ymm-results__panel" style="align-items:center;justify-content:center;min-height:200px">
        <div style="text-align:center;padding:40px">
          <div class="ymm-spinner"></div>
          <p style="color:#666;margin-top:16px;font-size:14px">Buscando partes para tu ${vehicleStr}...</p>
        </div>
      </div>`;
    const style = document.createElement('style');
    style.textContent = `
      #ymm-results-overlay{position:fixed;inset:0;z-index:10000;display:flex;align-items:flex-end;justify-content:center}
      .ymm-results__backdrop{position:absolute;inset:0;background:rgba(0,0,0,0.6)}
      .ymm-results__panel{position:relative;background:#fff;width:100%;max-width:1100px;border-radius:16px 16px 0 0;z-index:1;display:flex}
      .ymm-spinner{width:40px;height:40px;border:3px solid #eee;border-top-color:#0E1B47;border-radius:50%;animation:spin 0.8s linear infinite;margin:0 auto}
      @keyframes spin{to{transform:rotate(360deg)}}`;
    document.head.appendChild(style);
    document.body.appendChild(overlay);
  }

  async function doSearch(vehicle) {
    showLoading(vehicle);
    const { products, totalCount, searchUrl } = await searchByVehicle(vehicle);
    showResults(vehicle, products, totalCount, searchUrl);
  }

  // ── Modal (v11: Year → Make → Model → Engine) ─────────────────────────────
  function buildModal(onSave, prefill) {
    const overlay = document.createElement('div');
    overlay.id = 'ymm-modal-overlay';
    overlay.innerHTML = `<div id="ymm-modal">
      <h2 id="ymm-modal-title">&#xBF;Para qu&#xE9; veh&#xED;culo buscas?</h2>
      <p id="ymm-modal-sub">Selecciona tu veh&#xED;culo para ver solo las partes compatibles</p>
      <div id="ymm-modal-selects">
        <select id="ymm-m-year"><option value="">A&#xF1;o</option></select>
        <select id="ymm-m-make" disabled><option value="">Marca</option></select>
        <div style="grid-column:1/-1">
          <input id="ymm-m-model-search" type="text" placeholder="&#x1F50D; Buscar modelo..." autocomplete="off"
            style="width:100%;padding:9px 10px;border:1px solid #ddd;border-radius:6px;font-size:13px;box-sizing:border-box;margin-bottom:6px;display:none"/>
          <select id="ymm-m-model" disabled style="width:100%"><option value="">Modelo</option></select>
        </div>
        <select id="ymm-m-engine" disabled><option value="">Motor / Variante</option></select>
      </div>
      <div id="ymm-modal-actions">
        <button id="ymm-m-submit" disabled>Ver partes para mi veh&#xED;culo</button>
        <button id="ymm-m-skip">Cerrar</button>
      </div>
    </div>`;
    document.body.appendChild(overlay);

    const mYear=document.getElementById('ymm-m-year'), mMake=document.getElementById('ymm-m-make');
    const mModel=document.getElementById('ymm-m-model'), mEngine=document.getElementById('ymm-m-engine');
    const mSubmit=document.getElementById('ymm-m-submit'), mSkip=document.getElementById('ymm-m-skip');
    const modelSearch=document.getElementById('ymm-m-model-search');
    let currentModelList = [];

    fillSelect(mYear, getAllYears(), 'A\xF1o');
    mYear.disabled = false;

    function applyModelFilter(query) {
      const q = query.toLowerCase().trim();
      const filtered = q ? currentModelList.filter(m => m.toLowerCase().includes(q)) : currentModelList;
      fillSelect(mModel, filtered, filtered.length ? 'Selecciona modelo' : 'Sin resultados');
      mModel.disabled = filtered.length === 0;
      fillSelect(mEngine, [], 'Motor / Variante');
      mSubmit.disabled = true;
    }
    if (modelSearch) modelSearch.addEventListener('input', () => applyModelFilter(modelSearch.value));

    function setModelList(models) {
      currentModelList = models;
      fillSelect(mModel, models, models.length ? 'Selecciona modelo' : 'Sin modelos');
      mModel.disabled = models.length === 0;
      if (modelSearch) {
        modelSearch.value = '';
        modelSearch.style.display = models.length > 5 ? 'block' : 'none';
      }
    }

    // Cascade: Year → Make → Model → Engine
    mYear.addEventListener('change', () => {
      const year = mYear.value;
      fillSelect(mMake, year ? getMakesForYear(year) : [], 'Marca');
      mMake.disabled = !year;
      setModelList([]);
      fillSelect(mEngine, [], 'Motor / Variante');
      mSubmit.disabled = true;
    });
    mMake.addEventListener('change', () => {
      setModelList((mYear.value && mMake.value) ? getModelsForYear(mMake.value, mYear.value) : []);
      fillSelect(mEngine, [], 'Motor / Variante');
      mSubmit.disabled = true;
    });
    mModel.addEventListener('change', () => {
      fillSelect(mEngine,
        (mYear.value && mMake.value && mModel.value) ? getEngines(mMake.value, mModel.value, mYear.value) : [],
        'Motor / Variante');
      mSubmit.disabled = true;
    });
    mEngine.addEventListener('change', () => { mSubmit.disabled = !mEngine.value; });

    // VIN pre-fill: year + make locked, model list filtered to that year
    if (prefill && prefill.make) {
      fillSelect(mYear, [prefill.year], prefill.year);
      mYear.value = prefill.year || '';
      mYear.disabled = !!prefill.year;

      fillSelect(mMake, [prefill.make], prefill.make);
      mMake.value = prefill.make;
      mMake.disabled = true;

      const modelList = prefill.modelFilter ||
        (prefill.year ? getModelsForYear(prefill.make, prefill.year) : getModels(prefill.make));
      setModelList(modelList);

      mModel.addEventListener('change', () => {
        fillSelect(mEngine,
          (prefill.year && prefill.make && mModel.value)
            ? getEngines(prefill.make, mModel.value, prefill.year)
            : [],
          'Motor / Variante');
        mSubmit.disabled = true;
      });

      document.getElementById('ymm-modal-sub').textContent =
        `VIN decodificado: ${prefill.make} ${prefill.year || ''} \u2014 selecciona tu modelo y motor:`;
    }

    mSubmit.addEventListener('click', () => {
      const v = { make: mMake.value, model: mModel.value, year: mYear.value, engine: mEngine.value };
      saveVehicle(v); overlay.remove(); updateBar();
      if (onSave) onSave(v); else doSearch(v);
    });
    mSkip.addEventListener('click', () => overlay.remove());
  }

  // ── Bar ───────────────────────────────────────────────────────────────────
  function updateBar() {
    const v=getVehicle();
    const noV=document.getElementById('ymm-bar-novehicle'), hasV=document.getElementById('ymm-bar-hasvehicle'), lbl=document.getElementById('ymm-bar-label');
    if(v&&v.make&&v.model&&v.year&&v.engine) {
      if(noV)noV.style.display='none'; if(hasV)hasV.style.display='flex'; if(lbl)lbl.textContent=`${v.year} ${v.make} ${v.model} ${v.engine}`;
    } else { if(noV)noV.style.display='flex'; if(hasV)hasV.style.display='none'; }
  }

  function initBar() {
    const changeBtn=document.getElementById('ymm-bar-change'), clearBtn=document.getElementById('ymm-bar-clear'), selectBtn=document.getElementById('ymm-bar-select');
    if(changeBtn) changeBtn.addEventListener('click',()=>{clearVehicle();buildModal();updateBar();});
    if(clearBtn)  clearBtn.addEventListener('click',()=>{clearVehicle();updateBar();});
    if(selectBtn) selectBtn.addEventListener('click',()=>buildModal());

    const hasVehicle=document.getElementById('ymm-bar-hasvehicle');
    if(hasVehicle) {
      const searchBtn=document.createElement('button');
      searchBtn.className='ymm-bar__btn ymm-bar__search-btn';
      searchBtn.innerHTML='&#128269; Buscar';
      searchBtn.style.cssText='background:#A8202A;color:#fff;border-color:#A8202A;font-weight:600';
      searchBtn.addEventListener('click',()=>{const v=getVehicle();if(v)doSearch(v);});
      const actions=hasVehicle.querySelector('.ymm-bar__actions');
      if(actions) actions.prepend(searchBtn);
    }
    updateBar();
  }

  // ── Fitment badge ─────────────────────────────────────────────────────────
  function checkFitment() {
    const fitmentEl=document.getElementById('ymm-fitment-data');
    if(!fitmentEl) return;
    const v=getVehicle();
    if(!v||!v.make||!v.model||!v.year) return;
    let fitmentData;
    try {
      let raw=fitmentEl.textContent.trim();
      if(raw.includes('=>')) raw='['+raw.replace(/\}\s*\{/g,'},{').replace(/=>/g,':')+']';
      if(raw.trim().startsWith('{')) raw='['+raw+']';
      fitmentData=JSON.parse(raw);
    } catch(e){return;}

    const year=parseInt(v.year), makeUpper=v.make.toUpperCase(), modelFirst=v.model.toUpperCase().split(' ')[0], engUpper=(v.engine||'').toUpperCase();
    const exactFit=fitmentData.some(entry=>{
      const em=(entry.make||'').toUpperCase(), mo=(entry.model||'').toUpperCase(), tn=(entry.type_name||entry.typename||'').toUpperCase();
      const yf=parseInt(entry.year_from)||0, yt=entry.year_to?parseInt(entry.year_to):null;
      const yearOk=year>=yf&&(yt===null||year<=yt);
      const engineMatch=!engUpper||(()=>{if(!tn)return true;if(tn===engUpper)return true;const re=new RegExp('\\b'+tn.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'\\b');if(re.test(engUpper))return true;const re2=new RegExp('\\b'+engUpper.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'\\b');return re2.test(tn);})();
      return em===makeUpper&&mo.includes(modelFirst)&&yearOk&&engineMatch;
    });
    const broadFit=!exactFit&&fitmentData.some(entry=>{
      const em=(entry.make||'').toUpperCase(), mo=(entry.model||'').toUpperCase();
      const yf=parseInt(entry.year_from)||0, yt=entry.year_to?parseInt(entry.year_to):null;
      return em===makeUpper&&mo.includes(modelFirst)&&year>=yf&&(yt===null||year<=yt);
    });

    const badge=document.getElementById('ymm-fitment-badge');
    if(!badge) return;
    const vehicleStr=`${v.year} ${v.make} ${v.model} ${v.engine||''}`.trim();
    if(exactFit){badge.innerHTML=`&#10003; Compatible con tu ${vehicleStr}`;badge.className='ymm-fitment-badge ymm-fitment-badge--fits';}
    else if(broadFit){badge.innerHTML=`&#9888; El modelo aplica pero verifica tu motor: ${v.engine}`;badge.className='ymm-fitment-badge ymm-fitment-badge--warn';}
    else{badge.innerHTML=`&#10007; No verificado para tu ${vehicleStr}`;badge.className='ymm-fitment-badge ymm-fitment-badge--nofit';}
    badge.style.display='block';
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', async () => {
    await loadData();
    initBar();
    initVINInput();
    checkFitment();
  });

})();